class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    this.priceRangeSubmit = this.querySelector('.js-price-range__submit');
    this.priceRangeSubmit && this.priceRangeSubmit.addEventListener('click', this.onSubmitHandler.bind(this));
    this.debouncedOnSubmit = debounce((event) => {
      if (
        event.target.id == 'SortBy' ||
        event.target.classList.contains('facet-checkbox-sort') ||
        event.target.id == 'apply_filter' ||
        event.target.classList.contains('mobile-facets__checkbox') ||
        event.target.id == 'pagination'
      ) {
        this.onSubmitHandler(event);
      }
    }, 500);
    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    // TODO: This logic is unnecessarily complex. It adds a click listener only to immediately trigger it with a fake click.
    // Refactor to call `this.debouncedOnSubmit(e)` directly and remove the extra listener and `.click()` call.
    // also we have make sure overflow class removed once details are closed
    this.addEventListener('click', function (e) {
      if (e.target.id == 'apply_filter') {
        e.target.addEventListener('click', this.debouncedOnSubmit.bind(this));
        e.target.click();
        e.target.closest('details').removeAttribute('open');
      }
    });

    this.addEventListener('click', function (e) {
      if (
        e.target.classList.contains('js-details-close') ||
        e.target.classList.contains('mobile-facets') ||
        e.target.classList.contains('mobile_sort_container')
      ) {
        e.target.closest('details').removeAttribute('open');
        document.querySelector('body').classList.remove('overflow-hidden-mobile');
        document.querySelector('body').classList.remove('overflow-hidden');
      }
    });

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);

    this.addEventListener('click', (event) => {
      const moreFilter = event.target.closest('.mobile_accordion_header');
      if (moreFilter) {
        moreFilter.nextElementSibling?.classList.toggle('open');
      }
    });

    this.querySelectorAll('.mobile-facets__list').forEach((metafieldFilterWrapper) => {
      let container = metafieldFilterWrapper.parentElement;
      metafieldFilterWrapper.addEventListener('scroll', function () {
        if (metafieldFilterWrapper.scrollLeft > 50) {
          container.classList.add('fadeout_left');
        } else {
          container.classList.remove('fadeout_left');
        }
        if (
          metafieldFilterWrapper.scrollLeft + metafieldFilterWrapper.offsetWidth <
          metafieldFilterWrapper.scrollWidth - 50
        ) {
          container.classList.add('fadeout_right');
        } else {
          container.classList.remove('fadeout_right');
        }
      });
    });

    this.facetParams = this.querySelectorAll('.facets__param');
    this.facetParams.forEach((param) => {
      param.addEventListener('click', this.onFilterClick);
    });

    document.addEventListener('click', (event) => {
      const facetsDisclosure = document.querySelector('.mobile-facets__disclosure');
      if (
        facetsDisclosure &&
        facetsDisclosure.hasAttribute('open') &&
        !event.target.closest('.mobile-facets__inner') &&
        !event.target.closest('.facets__wrapper') &&
        !event.target.closest('.mobile-facets__disclosure')
      ) {
        facetsDisclosure.removeAttribute('open');
        document.querySelector('body').classList.remove('overflow-hidden-mobile');
        document.querySelector('body').classList.remove('overflow-hidden');
      }
    });
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const productCounts = document.querySelectorAll('.js-product-count');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    productCounts && productCounts.forEach((element) => element.classList.add('loading'));
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;
      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });

    const elementsToUpdate = document.querySelectorAll('#product-grid li.grid__item');
    const gridSwitchers = document.querySelectorAll('grid-switcher');
    gridSwitchers.forEach((gridSwitcher) => {
      gridSwitcher.applyGridView(elementsToUpdate);
    });
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').querySelector('.js-product-count').innerHTML;
    const countDesk = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductCountDesktop').innerHTML;
    const countDeskData = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCountDesktop')
      .dataset.result;
    const productCounts = document.querySelectorAll('.js-product-count');
    const countContainerMobile = document.getElementById('ProductCountMobile');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    productCounts &&
      productCounts.forEach((element) => {
        element.innerHTML = count;
        element.classList.remove('loading');
      });
    if (countContainerMobile) countContainerMobile.innerHTML = countDeskData;
    if (containerDesktop) {
      containerDesktop.innerHTML = countDesk;
      containerDesktop.dataset.result = countDeskData;
      if (containerDesktop.dataset.result == containerDesktop.dataset.totalCount) {
        containerDesktop.classList.add('hidden');
      } else {
        containerDesktop.classList.remove('hidden');
      }
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter, #FacetSortFormMobile .js-filter'
    );
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter((element) => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);
    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (activeFacetsElement?.querySelector('.active-facets-heading') != null) {
        if (activeFacetsElement.querySelector('.active-facets__container').childElementCount >= 1) {
          activeFacetsElement.querySelector('.active-facets-heading').classList.remove('hidden');
        } else {
          activeFacetsElement.querySelector('.active-facets-heading').classList.add('hidden');
        }
      }
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting', 'facets-bar'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    const facetsContainer = document.getElementById('FacetFiltersFormMobile')?.closest('.facets-container');
    facetsContainer?.querySelector('menu-drawer').bindEvents();
    facetsContainer?.querySelector('facets-bar').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    const targetBackElement = target.querySelector('.active_value_count');
    const sourceBackElement = source.querySelector('.active_value_count');

    const targetBackButtonElement = target.querySelector('.active_value_count_button');
    const sourceBackButtonElement = source.querySelector('.active_value_count_button');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }

    if (targetBackElement && sourceBackElement) {
      target.querySelector('.active_value_count').outerHTML = source.querySelector('.active_value_count').outerHTML;
    }

    if (targetBackButtonElement && sourceBackButtonElement) {
      target.querySelector('.active_value_count_button').outerHTML =
        source.querySelector('.active_value_count_button').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    const forms = [];
    const isMobile =
      event.target.closest('form').id === 'FacetFiltersFormMobile' ||
      event.target.closest('form').id === 'FacetSortFormMobile';

    sortFilterForms.forEach((form) => {
      const shouldProcessForm =
        (!isMobile &&
          (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm')) ||
        (isMobile && (form.id === 'FacetFiltersFormMobile' || form.id === 'FacetSortFormMobile'));

      if (shouldProcessForm) {
        if (!isMobile) {
          const noJsElements = document.querySelectorAll('.no-js-list');
          noJsElements.forEach((el) => el.remove());
        }

        // Handle price filter logic
        const minInput = form.querySelector('input[name="filter.v.price.gte"]');
        const maxInput = form.querySelector('input[name="filter.v.price.lte"]');

        if (minInput && maxInput) {
          const maxRange = maxInput.getAttribute('max') || maxInput.getAttribute('placeholder');

          if (minInput.value == '0' && maxInput.value == maxRange) {
            minInput.disabled = true;
            maxInput.disabled = true;

            const params = this.createSearchParams(form);
            if (params.length > 0) {
              forms.push(params);
            }

            minInput.disabled = false;
            maxInput.disabled = false;
          } else {
            const params = this.createSearchParams(form);
            if (params.length > 0) {
              forms.push(params);
            }
          }
        } else {
          const params = this.createSearchParams(form);
          if (params.length > 0) {
            forms.push(params);
          }
        }
      }
    });
    // close sort details drawer before render the page
    const sortDetailsSubmitted = event.target.closest('.js-sort-details');
    if (sortDetailsSubmitted) {
      sortDetailsSubmitted.closest('menu-drawer')?.closeMenuDrawer(event);
    }

    // Filter out any empty strings before joining
    const filteredForms = forms.filter((form) => form.length > 0);
    FacetFiltersForm.renderPage(filteredForms.join('&'), event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  #abortController;
  connectedCallback() {
    this.#abortController = new AbortController();
    this.init();
    this.attachEventListeners();
  }

  disconnectedCallback() {
    this.#abortController.abort();
  }

  init() {
    this.rangeLowerBound = this.querySelector('.js-range__min');
    this.rangeHigherBound = this.querySelector('.js-range__max');
    this.textInputLowerBound = this.querySelector('.js-range-input__min');
    this.textInputHigherBound = this.querySelector('.js-range-input__max');
    this.facetFiltersForm = this.closest('facet-filters-form');
  }

  attachEventListeners() {
    this.textInputLowerBound.addEventListener('change', this.handleTextInputChange.bind(this, 'min'), {
      signal: this.#abortController.signal,
    });
    this.textInputHigherBound.addEventListener('change', this.handleTextInputChange.bind(this, 'max'), {
      signal: this.#abortController.signal,
    });

    this.rangeLowerBound.addEventListener('change', this.handleRangeChange.bind(this, 'min'), {
      signal: this.#abortController.signal,
    });
    this.rangeHigherBound.addEventListener('change', this.handleRangeChange.bind(this, 'max'), {
      signal: this.#abortController.signal,
    });

    this.rangeLowerBound.addEventListener('input', this.handleRangeInput.bind(this, 'min'), {
      signal: this.#abortController.signal,
    });
    this.rangeHigherBound.addEventListener('input', this.handleRangeInput.bind(this, 'max'), {
      signal: this.#abortController.signal,
    });
  }

  handleTextInputChange(type, event) {
    event.preventDefault();
    const isMin = type === 'min';
    const textInput = isMin ? this.textInputLowerBound : this.textInputHigherBound;
    const otherTextInput = isMin ? this.textInputHigherBound : this.textInputLowerBound;
    const rangeInput = isMin ? this.rangeLowerBound : this.rangeHigherBound;

    textInput.value = isMin
      ? Math.max(
          Math.min(parseInt(textInput.value), parseInt(otherTextInput.value || textInput.max) - 1),
          textInput.min
        )
      : Math.min(
          Math.max(parseInt(textInput.value), parseInt(otherTextInput.value || textInput.min) + 1),
          textInput.max
        );

    rangeInput.value = textInput.value;
    this.updateRangeStyle(rangeInput, type);

    if (this.facetFiltersForm) {
      this.facetFiltersForm.onSubmitHandler(event);
    }
  }

  handleRangeChange(type, event) {
    event.stopPropagation();
    const textInput = type === 'min' ? this.textInputLowerBound : this.textInputHigherBound;
    textInput.value = event.target.value;
    textInput.dispatchEvent(new Event('change', { bubbles: true }));
  }

  handleRangeInput(type, event) {
    const isMin = type === 'min';
    const textInput = isMin ? this.textInputLowerBound : this.textInputHigherBound;
    const otherTextInput = isMin ? this.textInputHigherBound : this.textInputLowerBound;

    event.target.value = isMin
      ? Math.min(parseInt(event.target.value), parseInt(otherTextInput.value || event.target.max) - 1)
      : Math.max(parseInt(event.target.value), parseInt(otherTextInput.value || event.target.min) + 1);

    textInput.value = event.target.value;
    this.updateRangeStyle(event.target, type);
  }

  updateRangeStyle(rangeInput, type) {
    const percentage = (parseInt(rangeInput.value) / parseInt(rangeInput.max)) * 100;
    rangeInput.parentElement.style.setProperty(`--range-${type}`, `${percentage}%`);
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    if (facetLink) {
      facetLink.setAttribute('role', 'button');
      facetLink.addEventListener('click', this.closeFilter.bind(this));
      facetLink.addEventListener('keyup', (event) => {
        event.preventDefault();
        if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
      });
    }
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

class FacetsBar extends HTMLElement {
  constructor() {
    super();
    this.bindEvents();
  }

  bindEvents() {
    this.facetsParam = this.querySelectorAll('.facets__param:not(.toggle-switch)');
    this.facetsParam.forEach((param) => {
      param.addEventListener('click', this.onFacetClick);
    });

    const toggleSwitches = this.querySelectorAll('.toggle-switch input[type="checkbox"]');
    toggleSwitches.forEach((toggle) => {
      toggle.addEventListener('change', this.onToggleChange.bind(this));
    });
  }

  onFacetClick(event) {
    let facetDisclosure = document.querySelector('.mobile-facets__disclosure');
    if (facetDisclosure) {
      facetDisclosure.classList.add('menu-opening');
      facetDisclosure.setAttribute('open', '');
      if (window.innerWidth < 750) {
        document.querySelector('body').classList.add('overflow-hidden-mobile');
      } else {
        document.querySelector('body').classList.add('overflow-hidden');
      }
    }
  }

  onToggleChange(event) {
    const value = event.target.value;
    const isChecked = event.target.checked;

    const targetForm = document.getElementById('FacetFiltersFormMobile');
    const targetCheckbox = targetForm?.querySelector(`input[value="${value}"]`);

    if (!targetCheckbox) return;

    targetCheckbox.checked = isChecked;

    const facetFiltersForm = targetForm.parentElement;

    const simulatedEvent = {
      preventDefault: () => {},
      target: targetCheckbox,
    };

    facetFiltersForm?.onSubmitHandler(simulatedEvent);
  }
}

customElements.define('facets-bar', FacetsBar);

class FacetSort extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.onSortClick);
  }

  onSortClick(event) {
    let sortDisclosure = document.querySelector('.sort_options');
    if (sortDisclosure) {
      sortDisclosure.classList.add('menu-opening');
      sortDisclosure.setAttribute('open', '');
      if (window.innerWidth < 750) {
        document.querySelector('body').classList.add('overflow-hidden-mobile');
      } else {
        document.querySelector('body').classList.add('overflow-hidden');
      }
    }
  }
}

customElements.define('facet-sort', FacetSort);

class GridSwitcher extends HTMLElement {
  constructor() {
    super();
    this.initGridSwitcher();
  }

  initGridSwitcher() {
    const gridButtons = this.querySelectorAll('.grid-switcher__button');
    const productItems = document.querySelectorAll('#product-grid li.grid__item');

    if (gridButtons.length && productItems.length) {
      // if gridView preference stored in sessionStorage, update active button
      const gridViewDesktop = sessionStorage.getItem('gridViewDesktop') || '4';
      const gridViewMobile = sessionStorage.getItem('gridViewMobile') || '2';

      this.updateGridButtons(gridButtons, gridViewDesktop, gridViewMobile);
      this.applyGridView(productItems);

      gridButtons.forEach((button) => {
        button.addEventListener('click', () => {
          this.handleGridButtonClick(button, gridButtons, productItems);
        });
      });
    }
  }

  updateGridButtons(gridButtons, gridViewDesktop, gridViewMobile) {
    gridButtons.forEach((button) => {
      if (button.dataset.grid === gridViewDesktop || button.dataset.grid === gridViewMobile) {
        button.classList.add('active');
      } else {
        button.classList.remove('active');
      }
    });
  }

  handleGridButtonClick(button, gridButtons, productItems) {
    gridButtons.forEach((btn) => btn.classList.remove('active'));

    button.classList.add('active');

    if (button.dataset.grid === '4' || button.dataset.grid === '3') {
      sessionStorage.setItem('gridViewDesktop', button.dataset.grid);
    }
    if (button.dataset.grid === '2' || button.dataset.grid === '1') {
      sessionStorage.setItem('gridViewMobile', button.dataset.grid);
    }

    this.applyGridView(productItems);
  }

  applyGridView(productItems) {
    const existingItems = document.querySelectorAll('#product-grid li.grid__item');
    this.updateGridClasses(existingItems);
    this.updateGridClasses(productItems);
  }

  updateGridClasses(itemsToUpdate) {
    let gridValueDesktop = sessionStorage.getItem('gridViewDesktop') || '4';
    let gridValueMobile = sessionStorage.getItem('gridViewMobile') || '2';
    itemsToUpdate.forEach((item) => {
      if (gridValueDesktop === '4') {
        item.classList.remove('grid--4-col-desktop');
        item.classList.add('grid--3-col-desktop');
      } else if (gridValueDesktop === '3') {
        item.classList.remove('grid--3-col-desktop');
        item.classList.add('grid--4-col-desktop');
      }
      if (gridValueMobile === '2') {
        item.classList.remove('grid--6-col');
        item.classList.add('grid--3-col');
      } else if (gridValueMobile === '1') {
        item.classList.remove('grid--3-col');
        item.classList.add('grid--6-col');
      }
    });
  }
}

customElements.define('grid-switcher', GridSwitcher);
